<template>
  <div class="full-width">
    <h4 class="mt-6">{{ $t("Categories") }}</h4>
    <v-row no-gutters v-if="categorys">
      <v-col>
          <!-- @change="getFilterdProducts(null, item.Id, null, false)" -->
        <v-checkbox
          class="mt-2"
          :label="$t(item.Name)"
          :value="item.Id"
          hide-details
          v-for="item in toBoShownCategorys"
          :key="item.Id"
        >
        </v-checkbox>
      </v-col>

      <v-col
        cols="12"
        class="pt-4 ml-1"
        v-if="numberOfShowenCategorys <= categorys.length"
      >
        <a
          class="text-decoration-underline"
          @click="numberOfShowenCategorys = categorys.length"
          v-if="numberOfShowenCategorys != categorys.length"
          >{{ $t("Show more") }}</a
        >
        <a
          class="text-decoration-underline"
          v-else
          @click="numberOfShowenCategorys = 5"
          >{{ $t("Show less") }}</a
        >
      </v-col>
    </v-row>
    <h4 class="mt-6">{{ $t("Colors") }}</h4>
    <v-row v-if="colors" no-gutters>
      <v-col
        cols="2"
        v-for="(item, index) in toBoShownColors"
        :key="item.Image"
      >
        <v-sheet
          color="primary"
          height="28"
          width="28"
          class="rounded-xl"
          v-if="color[index]"
        >
          <v-layout class="mt-2" align-center justify-center fill-height>
            <v-avatar
              size="24"
              @click="changeColor(index)"
              class="pointer"
              :color="item.Image"
            >
            </v-avatar>
          </v-layout>
        </v-sheet>
        <v-layout class="mt-2" v-else>
          <v-avatar
            size="28"
            @click="changeColor(index)"
            class="pointer"
            :color="item.Image"
          >
          </v-avatar>
        </v-layout>
      </v-col>
      <v-col
        cols="12"
        class="mt-4"
        v-if="numberOfShowenColors <= colors.length"
      >
        <a
          class="text-decoration-underline"
          @click="numberOfShowenColors = colors.length"
          v-if="numberOfShowenColors != colors.length"
          >{{ $t("Show more") }}</a
        >
        <a
          class="text-decoration-underline"
          v-else
          @click="numberOfShowenColors = 5"
          >{{ $t("Show less") }}</a
        >
      </v-col>
    </v-row>

    <h4 class="mt-6">{{ $t("Collections") }}</h4>
    <v-row no-gutters v-if="seasons">
        <!-- @change="getFilterdProducts(item.Id, null, null, false)" -->
      <v-col>
        <v-checkbox
          class="mt-2"
          :label="$t(item.Name)"
          :value="item.Id"
          hide-details
          v-for="item in toBoShownSeasons"
          :key="item.Name"
        >
        </v-checkbox>
      </v-col>

      <v-col
        cols="12"
        class="mt-4"
        v-show="numberOfShowenSeasons <= seasons.length"
      >
        <a
          class="text-decoration-underline"
          @click="numberOfShowenSeasons = seasons.length"
          v-if="numberOfShowenSeasons != seasons.length"
          >{{ $t("Show more") }}</a
        >
        <a
          class="text-decoration-underline"
          v-else
          @click="numberOfShowenSeasons = 5"
          >{{ $t("Show less") }}</a
        >
      </v-col>
    </v-row>
  </div>
</template>
  
  <script>
import Vue from "vue";

export default {
  data() {
    return {
      apiUrl: this.$config.apiUrls.Dev,
      seasons: [],
      categorys: null,
      colors: null,
      stayFresh: [{ Name: "StayFresh", Id: "" }],
      stayFreshBox: false,
      color: [],
      seasonsFilterArray: [],
      categorysFilterArray: [],
      colorsFilterArray: [],
      numberOfShowenSeasons: 5,
      numberOfShowenCategorys: 5,
      numberOfShowenColors: 5,
      categoryCheckbox: null,
      seasonCheckbox: null,
      isSalesAgent: false,
    };
  },
  created() {
    this.categorys = [
      { Id: "1", Name: "Dresses" },
      { Id: "2", Name: "Tops & T-shirts" },
      { Id: "3", Name: "Blouses" },
      { Id: "4", Name: "Trousers" },
      { Id: "5", Name: "Jeans" },
      { Id: "6", Name: "Skirts" },
      { Id: "7", Name: "Swimwear" },
      { Id: "8", Name: "Sweaters & Cardigans" },
      { Id: "9", Name: "Jackets" },
    ];
    this.colors = [
      { Id: "1", Image: "#F44336" },
      { Id: "2", Image: "#E91E63" },
      { Id: "3", Image: "#9C27B0" },
      { Id: "4", Image: "#673AB7" },
      { Id: "5", Image: "#3F51B5" },
      { Id: "6", Image: "#2196F3" },
      { Id: "7", Image: "#03A9F4" },
      { Id: "8", Image: "#00BCD4" },

      { Id: "9", Image: "#009688" },
      { Id: "10", Image: "#4CAF50" },
      { Id: "11", Image: "#8BC34A" },
      { Id: "12", Image: "#CDDC39" },
      { Id: "13", Image: "#FFEB3B" },
      { Id: "14", Image: "#FFC107" },
      { Id: "15", Image: "#FF9800" },
      { Id: "16", Image: "#FF5722" },
      { Id: "17", Image: "#795548" },
      { Id: "18", Image: "#607D8B" },
      { Id: "19", Image: "#9E9E9E" },
      { Id: "20", Image: "#000000" },
      { Id: "21", Image: "#616161" },
      { Id: "22", Image: "#757575" },
      { Id: "23", Image: "#BDBDBD" },
      { Id: "24", Image: "#EEEEEE" },
    ];
    if (this.isSalesAgent) {
      this.seasons = [
        { Id: "1", Name: "Spring" },
        { Id: "2", Name: "Summer" },
        { Id: "3", Name: "Autumn" },
        { Id: "4", Name: "Winter" },
        {
          Id: "5",
          Name: "Spring" + " " + (new Date().getFullYear() - 1),
        },
        {
          Id: "6",
          Name: "Summer" + " " + (new Date().getFullYear() - 1),
        },
        {
          Id: "7",
          Name: "Autumn" + " " + (new Date().getFullYear() - 1),
        },
        {
          Id: "8",
          Name: "Winter" + " " + (new Date().getFullYear() - 1),
        },
      ];
    } else {
      this.seasons = [
        { Id: "1", Name: "Spring" },
        { Id: "2", Name: "Summer" },
        { Id: "3", Name: "Autumn" },
        { Id: "4", Name: "Winter" },
      ];
    }
  },
  computed: {
    currentLanguage: {
      get: function () {
        return Vue.i18n.locale();
      },
    },
    toBoShownCategorys() {
      return this.categorys.slice(0, this.numberOfShowenCategorys);
    },
    toBoShownColors() {
      return this.colors.slice(0, this.numberOfShowenColors);
    },
    toBoShownSeasons() {
      return this.seasons.slice(0, this.numberOfShowenSeasons);
    },
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    changeFilterItems(item) {
      this.$emit("changeFilterItems", item);
    },
    changeColor(index) {
      if (!this.color[index] || this.color[index] == undefined) {
        this.$set(this.color, index, true);
        /* this.getFilterdProducts(null, null, item.Id, false); */
      } else {
        /* this.getFilterdProducts(null, null, item.Id, false); */

        this.$set(this.color, index, false);
      }
    },
    async getFilterdProducts(season, category, color, stayFresh) {
      let seasonText, categoryText, colorText;
      //checking for more
      if (this.seasonsFilterArray.includes("&seasonIds=" + season)) {
        this.deleteItemFromArray(
          "&seasonIds=" + season,
          this.seasonsFilterArray
        );
      } else {
        if (season) {
          this.seasonsFilterArray.push(season);
        }
      }
      if (this.categorysFilterArray.includes("&categoryIds=" + category)) {
        if (category) {
          this.deleteItemFromArray(
            "&categoryIds=" + category,
            this.categorysFilterArray
          );
        }
      } else {
        if (category) {
          this.categorysFilterArray.push(category);
        }
      }

      this.colorsFilterArray.includes("&colorids=" + color)
        ? this.deleteItemFromArray("&colorids=" + color, this.colorsFilterArray)
        : color
        ? this.colorsFilterArray.push(color)
        : "";

      //adding text
      if (this.seasonsFilterArray.length > 0) {
        this.seasonsFilterArray = await this.filterAddText(
          this.seasonsFilterArray,
          "&seasonIds="
        );
      }
      //array to string
      seasonText = this.filtersToString(this.seasonsFilterArray);

      if (this.categorysFilterArray.length > 0) {
        this.categorysFilterArray = await this.filterAddText(
          this.categorysFilterArray,
          "&categoryIds="
        );
      }
      //array to string
      categoryText = this.filtersToString(this.categorysFilterArray);

      if (this.colorsFilterArray.length > 0) {
        this.colorsFilterArray = await this.filterAddText(
          this.colorsFilterArray,
          "&colorids="
        );
      }
      //array to string
      colorText = this.filtersToString(this.colorsFilterArray);

      //setup api string
      const apiString = `${
        seasonText + categoryText + colorText + "&isStayFresh=" + stayFresh
      }`;
      this.$emit("updateSortString", apiString);
    },
    filterAddText(items, text) {
      items.forEach((element, index) => {
        if (!element.includes(text)) {
          items[index] = text + element;
        }
      });
      return items;
    },
    filtersToString(items) {
      if (items) {
        let text = "";
        items.forEach((element) => {
          text = text + element;
        });
        return text;
      }
      return null;
    },
    deleteItemFromArray(id, items) {
      const index = items.indexOf(id);
      if (index > -1) {
        items.splice(index, 1);
      }

      return items;
    },
  },
};
</script>
  
  <style>
.full-width {
  width: 100%;
}
.pointer {
  cursor: pointer;
}
</style>